document.addEventListener('DOMContentLoaded', () => {
  const cartBubble = document.querySelector('.header__cart-count-number');
  const timeOut = 500;
  const timeOutCart = 1000;
  let timeOutCartId;
  const headers = {
    'Content-Type': 'application/json',
  };

  const updateCartDrawer = () => {
    clearTimeout(timeOutCartId);
    timeOutCartId = setTimeout( async () => {
      try {
        const mainCartDrawer = document.querySelector('cart-drawer');
        const response = await fetch('/?sections=cart-drawer');
        const data = await response.json();
        const parser = new DOMParser();
        const page = parser.parseFromString(data['cart-drawer'], 'text/html');
        const section = page.querySelector(`cart-drawer`);
        const cartCounter = page.querySelector(`#cart_bubble_counter`);
        cartBubble.innerHTML = cartCounter.value
        mainCartDrawer.innerHTML = section.innerHTML;
      } catch (error) {
        console.error(error);
      }
    }, timeOutCart);
  };


  const getInput = (id) => {
    const input = document.querySelector(
      `.input-quantity[data-product-id="${id}"]`
    );
    return input;
  };

  const updateTableWithItems = (id, quantity) => {
    const addToCartBtn = document.querySelector(
      `.add-to-cart-btn[data-product-id="${id}"]`
    );
    const inputBox = document.querySelector(
      `.input-selector[data-product-id="${id}"]`
    );
    const input = getInput(id);
    input.dataset.productQuantity = `${quantity}`;
    input.innerHTML = `${quantity}`;
    addToCartBtn.classList.add('hide');
    inputBox.classList.remove('hide');
  };

  const getCart = async () => {
    try {
      const request = await fetch('/cart.js');
      const response = await request.json();
      const { items } = response;
      items.forEach((item) => {
        updateTableWithItems(item.id, item.quantity);
      });
    } catch (e) {
      console.error(e);
    }
  };
  getCart();

  const addToCartBtns = document.querySelectorAll('.add-to-cart-btn');
  addToCartBtns.forEach((btn) => {
    btn.addEventListener('click', async () => {
      const id = btn.dataset.productId;
      const input = getInput(id);
      const quantity = input.dataset.productQuantity * 1 + 1;
      input.dataset.productQuantity = quantity;
      input.innerHTML = quantity;      
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers,
          body: JSON.stringify({ id, quantity: 1 }),
        });
        updateCartDrawer();
      } catch (e) {
        console.error(e);
      }
    });
  });

  const plusBtns = document.querySelectorAll('.input-selector-btn.plus');
  plusBtns.forEach((btn) => {
    let timeoutID;
    btn.addEventListener('click', () => {
      const id = btn.dataset.productId;
      const input = getInput(id);
      const maxQuantity = btn.dataset.max * 1;
      const quantity = input.dataset.productQuantity * 1 + 1;

      if (quantity > maxQuantity) return;
      input.dataset.productQuantity = quantity;
      input.innerHTML = quantity;
      clearTimeout(timeoutID);
      timeoutID = setTimeout(async () => {
        try {
          const updates = {};
          updates[id] = quantity;
          await fetch('/cart/update.js', {
            method: 'POST',
            headers,
            body: JSON.stringify({ updates: updates }),
          });
          updateCartDrawer();
          if (callback) callback(data);
        } catch (error) {
          console.error(error);
        }
      }, timeOut);
    });
  });

  const minusBtns = document.querySelectorAll('.input-selector-btn.minus');
  minusBtns.forEach((btn) => {
    let timeoutID;
    btn.addEventListener('click', () => {
      const id = btn.dataset.productId;
      const input = getInput(id);
      const quantity = input.dataset.productQuantity * 1 - 1;
      input.dataset.productQuantity = quantity;
      input.innerHTML = quantity;

      if (quantity === 0) {
        document
          .querySelector(`.input-selector[data-product-id="${id}"]`)
          .classList.add('hide');
        document
          .querySelector(`.add-to-cart-btn[data-product-id="${id}"]`)
          .classList.remove('hide');
      }
      clearTimeout(timeoutID);
      timeoutID = setTimeout( async () => {
        try {
          const updates = {};
          updates[id] = quantity;
          await fetch('/cart/update.js', {
            method: 'POST',
            headers,
            body: JSON.stringify({ updates: updates }),
          });
          await updateCartDrawer();
        } catch (e) {
          console.error(e);
        }
      }, timeOut);
    });
  });
});
